import { render, staticRenderFns } from "./ReportEmpty.vue?vue&type=template&id=2cf9e576&scoped=true&"
import script from "./ReportEmpty.vue?vue&type=script&lang=js&"
export * from "./ReportEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ReportEmpty.vue?vue&type=style&index=0&id=2cf9e576&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9e576",
  null
  
)

export default component.exports